import {Point} from "ol/geom";
import {viewFit} from "@/helpers/ol/ol-view";
import {setMapClickMarker} from "@/helpers/ol/ol-map-click-layer-helper";
import {addLocationMarker} from "@/helpers/ol/ol-route-helper";
import {getLatLonProjectionName, getViewProjection} from "@/helpers/ol/ol-projection-helper";
import {getDefaultZoom} from "@/helpers/ol/ol-zoom-helper.js";

export function goToCoordinate(coordinate) {
    let coordinates = coordinate.replace(/ /g, '').split(',');
    const    point = [parseFloat(coordinates[0]), parseFloat(coordinates[1])]
    const geometry = new Point(point)
    addLocationMarker(geometry.flatCoordinates)
    viewFit(geometry, undefined, getDefaultZoom())
}
